import {AbstractModel} from '../abstract-model';
import {Rate} from './rate';

export class OpenAiRate extends AbstractModel {
  rpd!: Rate;
  rpm!: Rate;
  tpd!: Rate;
  tpm!: Rate;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.rpd) {
      this.rpd = new Rate().deserialize(input.rpd);
    }

    if (input.rpm) {
      this.rpm = new Rate().deserialize(input.rpm);
    }

    if (input.tpd) {
      this.tpd = new Rate().deserialize(input.tpd);
    }

    if (input.tpm) {
      this.tpm = new Rate().deserialize(input.tpm);
    }

    return this;
  }

  isLimited(): boolean {
    return this.rpd.isLimited() || this.rpm.isLimited() || this.tpd.isLimited() || this.tpm.isLimited();
  }
}
